import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import axios from "axios";
import "../../style/contactPage/contactpage.scss";
import Header from "../work/header";

const JobDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // Get the ID from the URL params
  const [showModal, setShowModal] = useState(false);
  const [email, setEmail] = useState("");
  const [file, setFile] = useState(null);
  const [careerData, setCareerData] = useState([]);
  const API_BASE_URL = process.env.REACT_APP_SEARCH_API;

  // Fetch career data from API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/pages/110`);
        const data = response.data;
        const careers = Array.isArray(data?.acf?.career) ? data.acf.career : [];
        setCareerData(careers);
      } catch (error) {
        console.error("Error fetching data", error);
      }
    };

    fetchData();
  }, []);

  // Handle file selection
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  // Handle form submission
  const handleSubmit = () => {
    console.log("Email:", email);
    console.log("File:", file);
    setShowModal(false); // Close modal after submission
  };

  // Find the career details for the given ID
  const careerDetail = careerData.find(
    (career, index) => index.toString() === id
  );

  if (!careerDetail) return <div>Career not found.</div>;

  return (
    <div>
      <Header/>
      <Container className="py-5 mt-5">
        <div className="job-details-container">
          <h1 className="job-title">{careerDetail.career_title}</h1>
          <p className="job-subtitle">{careerDetail.career_desc}</p>
  
          <button className="submit-btn" onClick={() => setShowModal(true)}>
            {careerDetail.career_button}
          </button>
  
          {showModal && (
            <div className="modal-overlay">
              <div className="modal">
                <h2>Submit Your CV</h2>
                <input
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <input type="file" onChange={handleFileChange} />
                <div className="modal-buttons">
                  <button onClick={handleSubmit}>Submit</button>
                  <button onClick={() => setShowModal(false)}>Cancel</button>
                </div>
              </div>
            </div>
          )}
  
          <br />
          <div className="back-link" onClick={() => navigate("/contact")}>
            <ArrowLeft size={16} className="back-icon" />
            <span>Back to Career</span>
          </div>
        </div>
      </Container>
  
      <Container>
        {/* Summary */}
        <Row className="mb-5 summary-border mt-5">
          <Col md={3}>
            <h5 className="fw-semibold">
              {careerDetail.career_details?.summary_title}
            </h5>
          </Col>
          <Col md={9}>
            <div
              dangerouslySetInnerHTML={{
                __html: careerDetail.career_details?.summary_desc,
              }}
            />
          </Col>
        </Row>
  
        {/* Description */}
        <Row className="mb-5 summary-border">
          <Col md={3}>
            <h5 className="fw-semibold">
              {careerDetail.career_details?.desc_title}
            </h5>
          </Col>
          <Col md={9}>
            <div
              dangerouslySetInnerHTML={{
                __html: careerDetail.career_details?.desc_details,
              }}
            />
          </Col>
        </Row>
  
        {/* Responsibilities */}
        <Row className="mb-5 summary-border">
          <Col md={3}>
            <h5 className="fw-semibold">
              {careerDetail.career_details?.responsibilities_title}
            </h5>
          </Col>
          <Col md={9}>
            <div
              dangerouslySetInnerHTML={{
                __html: careerDetail.career_details?.responsibilities_desc,
              }}
            />
          </Col>
        </Row>
  
        {/* You Will Need */}
        <Row className="mb-5 summary-border">
          <Col md={3}>
            <h5 className="fw-semibold">
              {careerDetail.career_details?.you_will_need_title}
            </h5>
          </Col>
          <Col md={9}>
            <div
              dangerouslySetInnerHTML={{
                __html: careerDetail.career_details?.you_will_need_desc,
              }}
            />
          </Col>
        </Row>
  
        {/* Qualifications */}
        <Row className="mb-5 summary-border">
          <Col md={3}>
            <h5 className="fw-semibold">
              {careerDetail.career_details?.qualifications_title}
            </h5>
          </Col>
          <Col md={9}>
            <div
              dangerouslySetInnerHTML={{
                __html: careerDetail.career_details?.qualifications_desc,
              }}
            />
          </Col>
        </Row>
  
        <div className="justify-content-center d-flex">
          <button className="submit-btn" onClick={() => setShowModal(true)}>
            Submit CV
          </button>
        </div>
      </Container>
    </div>
  );
}
export default JobDetails;
